module.exports = __webpack_public_path__ + "img/jimny-glx-verde-obsesion.0a886d30.png";